import { lazy, Suspense } from 'react'
import { RouteObject } from 'react-router'
import { Navigate } from 'react-router-dom'
import SuspenseLoader from 'src/components/SuspenseLoader'
import SidebarLayout from './layouts/SidebarLayout'
import { MasterWorkoutMainTabs } from './pages/MasterWorkouts/Tabs'
import VimeoCallback from 'src/components/VimeoCallback'

const Loader = (Component) => (props) =>
	(
		<Suspense fallback={<SuspenseLoader />}>
			<Component {...props} />
		</Suspense>
	)

// Pages
const MasterExercises = Loader(lazy(() => import('src/pages/MasterExercises/List')))
const CreateEditMasterExercise = Loader(lazy(() => import('src/pages/MasterExercises/CreateOrEdit')))
const MasterWorkouts = Loader(lazy(() => import('src/pages/MasterWorkouts/List')))
const Analytics = Loader(lazy(() => import('src/pages/Analytics')))

const routes: RouteObject[] = [
	{
		path: '',
		element: <SidebarLayout />,
		children: [
			{
				path: '/',
				element: <Navigate to="/master-exercises" replace />,
			},
		],
	},
	{
		path: 'master-exercises',
		element: <SidebarLayout />,
		children: [
			{
				path: '',
				element: <MasterExercises />,
			},
			{
				path: 'create',
				element: <CreateEditMasterExercise />,
			},
			{
				path: ':id',
				element: <CreateEditMasterExercise />,
			},
		],
	},
	{
		path: 'master-workouts',
		element: <SidebarLayout />,
		children: [
			{
				index: true,
				element: <MasterWorkouts />,
			},
			{
				path: 'create',
				element: <MasterWorkoutMainTabs />,
			},
			{
				path: ':id',
				element: <MasterWorkoutMainTabs />,
			},
		],
	},
	{
		path: 'analytics',
		element: <SidebarLayout />,
		children: [
			{
				path: '',
				element: <Analytics />,
			},
		],
	},
	{
		path: 'vimeo-callback',
		element: <VimeoCallback />
	},
	{
		path: 'unauthorized',
		element: <h2>Token expired or unauthorized request! Please go to biolayne.com , refresh the page, and enter the admin page again.</h2>
	},
	{
		path: '*',
		element: <h1>page not found</h1>,
	}
]

export default routes
